var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad-box"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"ad-item"},[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_c('img',{attrs:{"src":item.url}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/practice/ad/middle.vue?vue&type=template&id=e17c09ee&scoped=true
// module id = null
// module chunks = 